import { ActionRow, Text } from '@viapeople/components'
import type { ReactNode } from 'react'

export const CycleSection = ({
	title,
	values,
	headers,
	onRowClick,
}: {
	title: string
	values: ReactNode[][]
	headers: string[]
	onRowClick: (cycleId: string) => void
}) => {
	if (!values || values.length === 0) return null

	return (
		<>
			<div className='mt-8 mb-5'>
				<Text variant='h5'>{title}</Text>
			</div>
			<div className='space-y-4'>
				{values.map((value) => {
					if (!value) return null
					const cycleId = value[value.length - 1]
					return (
						<ActionRow
							key={cycleId as string}
							headers={headers}
							values={value}
							onClick={() => onRowClick(cycleId as string)}
							className='cursor-pointer'
						/>
					)
				})}
			</div>
		</>
	)
}
